var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 20,
    viewBox: "119.69 -728 732.62 496",
    width: 20,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M604.59-232q-103.34 0-175.81-72.47t-72.47-175.81q0-102.57 72.47-175.14Q501.25-728 604.59-728q102.56 0 175.14 72.58 72.58 72.57 72.58 175.14 0 103.34-72.58 175.81T604.59-232m-.78-32q90.5 0 153.5-62.5t63-153-63-153.5-153-63q-91 0-153.5 63t-62.5 153q0 91 62.5 153.5t153 62.5M694-366.77l22.54-22.54-96.32-96.51v-125.87h-31.91v138.47zM167.69-620v-32h128.62v32zm-48 156v-32h176.62v32zm48 156v-32h128.62v32zm436.62-172"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcute);
export default __webpack_public_path__ + "static/media/acute.456d5009e2f86e3ca42e358007271f51.svg";
export { ForwardRef as ReactComponent };